import { connect } from 'react-redux'
import { User } from '../components'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { auth0 } = state.authentication
  const { userProfile, tabId, language } = state.user
  return ({
    auth0,
    userProfile,
    width,
    tabId,
    profileBoxSProps: {
      width,
      userProfile,
    },
    menuTabSProps: {
      userName: ownProps.match.params.userName,
      tabId
    },
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: (userName) => {
      dispatch(api.user.select(
        { userName },
        (dispatch, response) => {
          if (response.result === true || response.records.length === 1) {
            dispatch(actions.user.receiveUserProfile(response.records[0]))
          }
        }
      ))
    },
    unmount: () => {
      dispatch(actions.user.unmount())
    },
    handleChangeTab: (value) => {
      dispatch(actions.user.changedTab(value))
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(User)


// WEBPACK FOOTER //
// ./src/Pages/User/containers/User.js